import ajax from '@/lib/ajax'

// CreatePatientVascularAccess
// 创建血管通路
export async function CreatePatientVascularAccess(payload: any){
	let res = await ajax.post('/api/services/app/VascularAccess/CreatePatientVascularAccess', payload)
	return res.data.result
}
// EditPatientVascularAccess
// 编辑血管通路
export async function EditPatientVascularAccess(payload: any){
	let res = await ajax.post('/api/services/app/VascularAccess/EditPatientVascularAccess', payload)
	return res.data.result
}
// GetPatientVascularAccessList
// 查询血管通路列表
export async function GetPatientVascularAccessList(payload: any){
	let res = await ajax.get('/api/services/app/VascularAccess/GetPatientVascularAccessList', {params:payload})
	return res.data.result
}
// DeletePatientVascularAccess
// 删除血管通路
export async function DeletePatientVascularAccess(payload: any){
	let res = await ajax.delete('/api/services/app/VascularAccess/DeletePatientVascularAccess', {params:payload})
	return res.data.result
}

// CreatePatientVaEvent
// 创建血管通路事件
export async function CreatePatientVaEvent(payload: any){
	let res = await ajax.post('/api/services/app/VascularAccess/CreatePatientVaEvent', payload)
	return res.data.result
}
// EditPatientVaEvent
// 编辑血管通路事件
export async function EditPatientVaEvent(payload: any){
	let res = await ajax.post('/api/services/app/VascularAccess/EditPatientVaEvent', payload)
	return res.data.result
}
// DeletePatientVaEvent
// 删除血管通路事件
export async function DeletePatientVaEvent(payload: any){
	let res = await ajax.delete('/api/services/app/VascularAccess/DeletePatientVaEvent', {params:payload})
	return res.data.result
}
// GetPatientVaEventList
// 查询血管通路事件列表
export async function GetPatientVaEventList(payload: any){
	let res = await ajax.get('/api/services/app/VascularAccess/GetPatientVaEventList', {params:payload})
	return res.data.result
}



// WEBPACK FOOTER //
// ./src/api/vascularAccess/index.ts